export default "__VITE_ASSET__CFGLBn_n__"